module.exports = __webpack_public_path__ + "static/media/BG1.150e6859.png";